import { Link } from "react-router-dom";
import SiteLayout from "../components/SiteLayout";
import { XCircle, CalendarDays } from "lucide-react";

export default function PaymentCancel() {
  return (
    <SiteLayout>
      <section className="container-pad max-w-3xl mx-auto py-20">
        <div data-testid="payment-cancel-card" className="card-soft p-10 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-amber-500/15 text-amber-700 flex items-center justify-center">
            <XCircle className="w-7 h-7" strokeWidth={1.75} />
          </div>
          <h1 className="mt-5 font-heading text-2xl font-semibold text-ink">Payment cancelled.</h1>
          <p className="mt-3 text-muted_text leading-relaxed max-w-md mx-auto">
            No charge was made. Your appointment slot will be released shortly. You can start over anytime.
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link to="/contact" data-testid="cancel-book-again" className="btn-gold !text-sm">
              <CalendarDays className="w-4 h-4 mr-2" /> Book again
            </Link>
            <Link to="/" data-testid="cancel-back-home" className="btn-ghost">Back home</Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
